import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  createReturnUserStatusService,
  deleteReturnUserStatusService,
  getReturnUserStatusService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const returnUserStatusAdminContext = createContext({
  returnUserStatusItems: [],
  setReturnUserStatusItems: () => {},
  description: "",
  setDescription: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  handleShowModal: () => {},
  handleCloseModal: () => {},
  handleGetReturnUserStatusItemList: () => {},
  handleCreateReturnUserStatusItem: () => {},
  handleDeleteReturnUserStatusItem: () => {},
});

const ReturnUserStatusAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [returnUserStatusItems, setReturnUserStatusItems] = useState([]);
  const [description, setDescription] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);

  const handleResetState = () => {
    setDescription("");
  };

  // Create Return User Status Modal Operations
  const handleShowModal = () => setIsShowModal(true);
  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  // Handle Get Return User Status Item List Method
  const handleGetReturnUserStatusItemList = async (event) => {
    event?.preventDefault();
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getReturnUserStatusService();
      if (status === 200) {
        setReturnUserStatusItems(data.results);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create Return User Status Item Method
  const handleCreateReturnUserStatusItem = async (event) => {
    event?.preventDefault();

    const objData = {
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createReturnUserStatusService(objData);
      if (status === 200) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetReturnUserStatusItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Return User Status Item Method
  const handleDeleteReturnUserStatusItem = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteReturnUserStatusService(id);
      if (status === 200) {
        toastSuccessMessage(`آیتم  ${id} با موفقیت حذف شد`);
        handleGetReturnUserStatusItemList();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <returnUserStatusAdminContext.Provider
      value={{
        returnUserStatusItems,
        setReturnUserStatusItems,
        description,
        setDescription,
        isShowModal,
        setIsShowModal,
        handleShowModal,
        handleCloseModal,
        handleGetReturnUserStatusItemList,
        handleCreateReturnUserStatusItem,
        handleDeleteReturnUserStatusItem,
      }}
    >
      {children}
    </returnUserStatusAdminContext.Provider>
  );
};

export default ReturnUserStatusAdminContext;
